// extracted by mini-css-extract-plugin
export var actionText = "_mc-4";
export var container = "_mc-0";
export var leftSection = "_mc-1";
export var rightSection = "_mc-2";
export var settingsButton = "_mc-6";
export var settingsIcon = "_mc-7";
export var shortcut = "_mc-5";
export var shortcutGroup = "_mc-3";